import React from "react";
import { makeStyles } from '@material-ui/core/styles';
import { useTheme } from '@material-ui/core/styles';
import Backdrop from '@material-ui/core/Backdrop';

import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

import { useTranslation } from 'react-i18next';
import { SaveIcon } from "../atoms/icons/SaveIcon";
import LinearProgress  from "@material-ui/core/LinearProgress";



const useStyles = makeStyles((theme) => ({
    root: {
     
    },
    media: {
      height: 140,
    },
    errorCaption: {
        paddingTop: theme.spacing(2),
    },
    backdrop: {
        zIndex: theme.zIndex.modal + 2,
    }
  }));

interface IOptions {
    optionLabel: string;
    optionExecute: () => void;
}

interface IDecorations {
    entity?: string;
    options?: IOptions[];
}

export type AllProps = IDecorations;
export const SavingMessage = (props: AllProps) => {
    const theme = useTheme();
    const classes = useStyles(theme);
    const { t: tCommon } = useTranslation('common');
    
    return (
        <Backdrop open={true} className={classes.backdrop}>
            <Card className={classes.root}>
                <CardActionArea>
                    <CardContent>
                    <Typography gutterBottom variant="h5" component="h2" color="textPrimary">
                        <SaveIcon fontSize="large" />  {tCommon('savingTitle')}
                    </Typography>
                    <Typography variant="body1" color="textPrimary" component="p">
                        {props.entity ? tCommon('savingXMessage', {x: props.entity}) : tCommon('savingMessage')}
                    </Typography>
                    <LinearProgress />
                    </CardContent>
                </CardActionArea>
                <CardActions>
                    {props.options && props.options.map((option, index) => (
                        <Button key={index} size="small" color="primary" onClick={option.optionExecute}>
                            {option.optionLabel}
                        </Button>
                    ))}
                </CardActions>
            </Card>
        </Backdrop>
    );
}